import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  // Redirect unauthenticated users to landing page instead of login
  return user ? children : <Navigate to="/" />;
}

export default ProtectedRoute;
